import React, { useState, useEffect, useRef } from 'react';
import Header from "../../../Components/Header/Header";
import LeftMenu from '../../../Components/LeftMenu/LeftMenu';
import { Link } from '@mui/material';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowLeft, faCircleXmark } from '@fortawesome/free-solid-svg-icons';
import { toast } from 'react-toastify';
import { Tab, Tabs, Modal, Row, Col, Button, Form, Accordion, Table } from 'react-bootstrap';
import Trash from '../../../assets/images/trash.png';
import Docmnt from "../../../assets/images/google-docs.png";

import { withoutRFSToken, withRFSToken } from '../../../Services/axios.js';
import { DOWNLOADFILES, MSGSTATUSUPDATE, RECOVERYDETAILS, SAVECONVO, SROPENCLOSE } from '../../../Utils/conts.js';

const UpdateRecoveryCase = () => {

    const isMounted = useRef(false);
    const [isLoading, setIsLoading] = useState(false);
    const [recoveryDetails, seRecoveryDetails] = useState({});
    const [formData, setFormData] = useState([]);
    //     {
    //     handler_action: [
    //         { warehouse_check: false, warehouse_check_date: '', contacted_agent: false, contacted_agent_date: '' }
    //     ],
    // });
    const [recoveryAspects, setRecoveryAspects] = useState([
        { warehouse_check: false, warehouse_check_date: '', contacted_agent: false, contacted_agent_date: '' }
    ]);

    const loadDetails = async (storedData) => {
        setIsLoading(true)
        try {
            const res = await withRFSToken.post(RECOVERYDETAILS, { service_recovery_id: storedData.id })
                .then(function (res) {
                    const innerData = res.data.response_data;
                    if (res.data.response_code === 200) {
                        seRecoveryDetails(innerData);
                        const newAspect = { warehouse_check: false, warehouse_check_date: '', contacted_agent: false, contacted_agent_date: '' };
                        const transData = innerData?.stations?.map(prev => ({
                            ...prev,
                            handler_action: prev.handler_action.length == 0 ? [...prev.handler_action, newAspect] : prev.handler_action,
                            attachments: prev.attachments || [],
                            files: [],
                            showFiles: []
                        }));
                        if (storedData.stn) {
                            const findStn = transData?.find(st => st.station_name == storedData.stn)
                            setFormData([findStn])
                        } else {
                            setFormData(transData)
                        }
                    } else { toast.error(res.data.response_msg) }
                    setIsLoading(false)

                });
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };

    const backUrl = localStorage.getItem('BackRecoveryUpdate');

    useEffect(() => {
        if (isMounted.current) return;
        const storedData = JSON.parse(localStorage.getItem('RecoveryUpdate'));
        loadDetails(storedData)
        isMounted.current = true;
    }, []);

    // FORM
    const handleFormChange = (hfId, fieldName, value) => {

        setFormData(prevFormData => prevFormData.map(hndlr => {
            if (hndlr.handler_feedback_id === hfId) {
                return { ...hndlr, [fieldName]: value };
            }
            return hndlr;
        }));
        // const { name, value } = event.target;
        // const updatedData = { ...formData, [name]: value };
        // setFormData(updatedData);
    };
    // RECOVERY ASPECTS START
    const handleAddAspect = (hfId) => {
        if (recoveryAspects.length < 5) {
            const newAspect = { warehouse_check: false, warehouse_check_date: '', contacted_agent: false, contacted_agent_date: '' };
            // setRecoveryAspects([...recoveryAspects, newAspect]);

            setFormData(prevFormData => prevFormData.map(hndlr => {
                if (hndlr.handler_feedback_id === hfId) {
                    return { ...hndlr, handler_action: [...hndlr.handler_action, newAspect] };
                }
                return hndlr;
            }));
            // setFormData(prev => ({
            //     ...prev,
            //     handler_action: [...prev.handler_action, newAspect]
            // }));
        }
    };

    const handleRemoveAspect = (hfId, index) => {
        // setRecoveryAspects(updatedAspects);
        setFormData(prevFormData => prevFormData.map(hndlr => {
            if (hndlr.handler_feedback_id === hfId) {
                const updatedAspects = hndlr.handler_action.filter((_, i) => i !== index);
                return { ...hndlr, handler_action: updatedAspects };
            }
            return hndlr;
        }));
        // setFormData(prev => ({
        //     ...prev,
        //     handler_action: updatedAspects
        // }));
    };

    const handleInputChange = (hfId, index, field, value) => {

        // setRecoveryAspects(updatedAspects);
        setFormData(prevFormData => prevFormData.map(hndlr => {
            if (hndlr.handler_feedback_id === hfId) {
                const updatedAction = { ...hndlr.handler_action[index], [field]: value };
                const updatedAspects = [...hndlr.handler_action];
                updatedAspects[index] = updatedAction;

                return { ...hndlr, handler_action: updatedAspects };
            }
            return hndlr;
        }));

        // setFormData(prev => ({
        //     ...prev,
        //     handler_action: updatedAspects
        // }));
    };
    // RECOVERY ASPECTS End

    // IMAGE UPLOAD END
    const fileInputRef = useRef({});
    const [files, setFiles] = useState([]);
    const [base64Files, setBase64Files] = useState([]);

    const handleDragOver = (e) => {
        e.preventDefault();
    };

    const handleBrowseFiles = (e, handlerId) => {
        console.log('sawdsdasd', handlerId);

        e.preventDefault();
        if (fileInputRef.current[handlerId]) {
            fileInputRef.current[handlerId].click();
        } else {
            console.error("No input ref found for:", handlerId);
        }
    };

    const handleDrop = (e, handlerId) => {
        e.preventDefault();
        const droppedFiles = Array.from(e.dataTransfer.files);
        handleFiles(droppedFiles, handlerId);
    };

    const handleFileChange = (e, handlerId) => {
        const selectedFiles = Array.from(e.target.files);
        handleFiles(selectedFiles, handlerId);
    };

    const handleFiles = (selectedFiles, handlerId) => {
        const filesWithBase64 = [];
        let filesProcessed = 0;
        const existingFiles = formData?.files || [];

        selectedFiles.forEach((file) => {
            const reader = new FileReader();
            reader.onloadend = () => {
                filesWithBase64.push({ file, base64: reader.result, file_name: file.name });
                filesProcessed += 1;

                if (filesProcessed === selectedFiles.length) {
                    // const newFiles = filesWithBase64.map((obj) => obj.file);
                    const newBase64Files = filesWithBase64.map((obj) => ({ base64: obj.base64, file_name: obj.file_name }));
                    // const mergedBase64Files = [...existingBase64Files, ...newBase64Files];
                    const mergedFiles = [...existingFiles, ...newBase64Files];

                    setFormData((prevData) =>
                        prevData.map((section) => {
                            if (section.handler_feedback_id === handlerId) {
                                const existingFiles = section.files || [];
                                const newFiles = filesWithBase64.map((obj) => obj.file);
                                return {
                                    ...section,
                                    files: mergedFiles,
                                    showFiles: [...existingFiles, ...newFiles],
                                };
                            }
                            return section;
                        })
                    );
                }
            };
            reader.readAsDataURL(file);
        });
    };
    const handleDeleteFile = (handlerId, fileIndex) => {
        setFormData((prevData) =>
            prevData.map((section) => {
                if (section.handler_feedback_id === handlerId) {
                    const updatedFiles = [...(section.files || [])];
                    updatedFiles.splice(fileIndex, 1);
                    return {
                        ...section,
                        files: updatedFiles,
                    };
                }
                return section;
            })
        );
    };
    const handleDeleteImage = (handlerId, fileIndex) => {
        setFormData((prevData) =>
            prevData.map((section) => {
                if (section.handler_feedback_id === handlerId) {
                    const updatedFiles = [...(section.files || [])];
                    updatedFiles.splice(fileIndex, 1);
                    return {
                        ...section,
                        attachments: updatedFiles,
                    };
                }
                return section;
            })
        );
    };
    // IMAGE UPLOAD END

    const handleUpdate = async () => {
        console.log('payload', formData);
        const srId = JSON.parse(localStorage.getItem('RecoveryUpdate'))
        try {
            const res = await withRFSToken.post('service-recovery/update', { station: formData, service_recovery_id: srId?.id })
                .then(function (res) {
                    const innerData = res.data.response_data;
                    if (res.data.response_code === 200) {
                        window.location.replace('/OverviewDetails')
                    } else { toast.error(res.data.response_msg) }


                });
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    }

    return (
        <>
            {console.log('formData', formData)}
            {/* {console.log('recoveryDetails', recoveryDetails)} */}
            <div className="">
                <Header page_type='srecovery' logo_url='/ServiceRecovery' />
                <div className="page-body-wrapper schedule">
                    <LeftMenu />
                    {isLoading ?
                        <div className='mvt loader-container' style={{ top: '0', height: '1084px' }}><span className='mvt loader' style={{ left: 'calc(50% - 17px)', top: '40vh' }}></span></div>
                        :
                        <div className="main-panel rounded">
                            {/* <Link to='/AddRecovery' className='stk_back'> <FontAwesomeIcon icon={faArrowLeft} /> Back</Link> */}
                            <button className='exportbtn me-3' onClick={() => window.location.replace(backUrl)}>
                                <FontAwesomeIcon icon={faArrowLeft} /> <span>Back</span><span>{recoveryDetails?.master_airway_bill_prefix + ' - ' + recoveryDetails?.master_airway_bill_no}</span>
                            </button>
                            <div className="mainTab my-3">
                                <div className='update_reco_title'>
                                    <h3>Update Recovery Case - AWB {recoveryDetails?.master_airway_bill_prefix + ' - ' + recoveryDetails?.master_airway_bill_no}</h3>
                                    <h4>Update recovery details and findings for the handler listed bellow</h4>
                                </div>

                                <div className='service_recovery_form d-flex justify-content-center flex-wrap'>
                                    {formData?.map((stn, index) => (
                                        <div className='recover_middle'>
                                            <h5>{stn.station_name} - <span>{stn.handler_name}</span></h5>
                                            <Form.Group as={Row} className="mb-1">
                                                <Col >
                                                    <Form.Label>Pieces Traced</Form.Label>
                                                    <Form.Control
                                                        type="number"
                                                        placeholder=""
                                                        name='pieces_traced'
                                                        value={stn.pieces_traced || ''}
                                                        onChange={(e) => handleFormChange(stn.handler_feedback_id, 'pieces_traced', e.target.value)}
                                                    />
                                                </Col>
                                                <Col >
                                                    <Form.Label>Tracing Date </Form.Label>
                                                    <Form.Control
                                                        type="date"
                                                        placeholder=""
                                                        name='tracing_date'
                                                        value={stn.tracing_date || ''}
                                                        onChange={(e) => handleFormChange(stn.handler_feedback_id, 'tracing_date', e.target.value)}

                                                    />
                                                </Col>
                                            </Form.Group>
                                            <div>
                                                <Form.Label>Recovery Aspects </Form.Label>
                                                <Form.Group as={Row} className="mb-1">
                                                    {stn?.handler_action?.map((aspect, index) => (
                                                        <React.Fragment key={index}>
                                                            <Col className='mb-2'>
                                                                <div className='warehose'>
                                                                    <Form.Check
                                                                        inline
                                                                        type="checkbox"
                                                                        id={`warehouseCheck${index}`}
                                                                        className="warehouse_check"
                                                                        label={`Warehouse Check - ${index + 1}`}
                                                                        checked={aspect.warehouse_check}
                                                                        onChange={(e) => handleInputChange(stn.handler_feedback_id, index, 'warehouse_check', e.target.checked)}
                                                                    />
                                                                    <Form.Control
                                                                        type="date"
                                                                        placeholder=""
                                                                        name="warehouse_check_date"
                                                                        value={aspect.warehouse_check_date}
                                                                        onChange={(e) => handleInputChange(stn.handler_feedback_id, index, 'warehouse_check_date', e.target.value)}
                                                                    />
                                                                </div>
                                                            </Col>
                                                            <Col className='mb-2 position-relative'>
                                                                <div className='warehose'>
                                                                    <Form.Check
                                                                        inline
                                                                        type="checkbox"
                                                                        id={`contactedAgent${index}`}
                                                                        className=""
                                                                        label={`Contacted Agent - ${index + 1}`}
                                                                        checked={aspect.contacted_agent}
                                                                        onChange={(e) => handleInputChange(stn.handler_feedback_id, index, 'contacted_agent', e.target.checked)}
                                                                    />
                                                                    <Form.Control
                                                                        type="date"
                                                                        placeholder=""
                                                                        name="contacted_agent_date"
                                                                        value={aspect.contacted_agent_date}
                                                                        onChange={(e) => handleInputChange(stn.handler_feedback_id, index, 'contacted_agent_date', e.target.value)}
                                                                    />
                                                                </div>
                                                                {stn?.handler_action?.length > 1 &&
                                                                    <Link to="#" onClick={() => handleRemoveAspect(stn.handler_feedback_id, index)} className='handler_trash'>
                                                                        <img src={Trash} />
                                                                    </Link>
                                                                }
                                                            </Col>
                                                        </React.Fragment>
                                                    ))}
                                                    <Col md="12">
                                                        <Button variant="outline-primary" className='more_btn mt-3' onClick={() => handleAddAspect(stn.handler_feedback_id)}>
                                                            Add More Aspects
                                                        </Button>
                                                    </Col>
                                                </Form.Group>
                                            </div>
                                            <div>
                                                <Form.Label>Remarks</Form.Label>
                                                <Form.Control
                                                    as="textarea"
                                                    placeholder=""
                                                    name='remarks'
                                                    value={stn.remarks || ''}
                                                    onChange={(e) => handleFormChange(stn.handler_feedback_id, 'remarks', e.target.value)}
                                                />
                                            </div>
                                            <div>
                                                <Form.Label>File Upload </Form.Label>
                                                <div className="dropfile " onDrop={(e) => handleDrop(e, stn.handler_feedback_id)} onDragOver={handleDragOver}>
                                                    <h3>Drag and drop files here</h3>
                                                    <button className='btn btn-primary drpbtn' onClick={(e) => handleBrowseFiles(e, stn.handler_feedback_id)}>Browse Files</button>
                                                    <span>Maximum file size 4 MB</span>
                                                    <input
                                                        type="file"
                                                        ref={(el) => (fileInputRef.current[stn.handler_feedback_id] = el)}
                                                        style={{ display: 'none' }}
                                                        onChange={(e) => handleFileChange(e, stn.handler_feedback_id)}
                                                        multiple
                                                    />
                                                </div>
                                            </div>
                                            <div className='d-flex upimg_recover'>
                                                {stn?.attachments.length > 0 &&
                                                    <>
                                                        {stn?.attachments?.map((file, index) => {
                                                            const fileName = file?.file_name;
                                                            console.log("🚀 ~ {files.map ~ file:", file)
                                                            const baseName = fileName?.substring(0, fileName.lastIndexOf("."));
                                                            const extension = fileName?.split(".").pop();
                                                            return (
                                                                <>

                                                                    {file.original_file_path == 'service_recovery_handler_feedback_edit_files' &&
                                                                        <>
                                                                            <div key={`ns_${index}`} className='img-thumbnail'>
                                                                                {["jpeg", "jpg", "png", "webp"].includes(file.file_path?.split(".")[file.file_path?.split(".").length - 1]
                                                                                ) ? (
                                                                                    <>
                                                                                        <img
                                                                                            src={file.file_path}
                                                                                            alt="Preview"
                                                                                            style={{
                                                                                                maxWidth: "30px",
                                                                                                maxHeight: "30px",
                                                                                                marginRight: "10px",
                                                                                            }}
                                                                                        // onClick={() => handleFileClick(URL.createObjectURL(file))}
                                                                                        // onClick={() =>
                                                                                        //   handleFileClick(file.file_path)
                                                                                        // }
                                                                                        />
                                                                                    </>
                                                                                ) : (
                                                                                    <>
                                                                                        <span className="">
                                                                                            <img src={Docmnt} className="fileimg" />
                                                                                        </span>
                                                                                    </>
                                                                                )}
                                                                                <span className="rafilename">
                                                                                    {baseName?.length <= 7 ? fileName : `${baseName?.substring(0, 7)}... .${extension}`}
                                                                                </span>
                                                                                <button
                                                                                    className="dltbtn"
                                                                                    type="button"
                                                                                    onClick={() =>
                                                                                        handleDeleteImage(index, file.id, file.attachment_type)
                                                                                    }
                                                                                >
                                                                                    <FontAwesomeIcon icon={faCircleXmark} />
                                                                                </button>
                                                                            </div>
                                                                        </>
                                                                    }
                                                                </>
                                                            );
                                                        })}
                                                    </>
                                                }
                                                {stn?.showFiles.map((file, index) => {
                                                    const fileName = file.name;
                                                    const baseName = fileName?.substring(0, fileName.lastIndexOf("."));
                                                    console.log("🚀 ~ {files.map ~ baseName:", baseName)
                                                    const extension = fileName?.split(".").pop();
                                                    return (
                                                        // <div key={index} className={`img-thumbnail ${selectedKeys.includes(index) ? 'primaryimg' : ''}`} onClick={() => handleImageSelect(index, file)}>
                                                        <div key={index} className='img-thumbnail'>
                                                            {["jpeg", "jpg", "png", "webp"].includes(file.name.split(".")[file.name.split(".").length - 1]
                                                            ) ? (
                                                                <>
                                                                    <img
                                                                        src={URL.createObjectURL(file)}
                                                                        alt="Preview"
                                                                        style={{
                                                                            maxWidth: "30px",
                                                                            maxHeight: "30px",
                                                                            marginRight: "5px",
                                                                        }}
                                                                    // onClick={() => handleFileClick(URL.createObjectURL(file))}
                                                                    // onClick={() => handleFileClick(file.file_path)}
                                                                    />
                                                                    <span>
                                                                        {/*file.file_name*/}
                                                                        {baseName?.length <= 7 ? fileName : `${baseName?.substring(0, 40)}... .${extension}`}
                                                                    </span>
                                                                </>
                                                            ) : (
                                                                <>
                                                                    <span className="d-flex align-items-center">
                                                                        <img src={Docmnt} className="fileimg" />
                                                                        <span>{file.name}</span>
                                                                    </span>
                                                                </>
                                                            )}
                                                            {/* {file.type.startsWith('image/') ? (
                                                                            <img
                                                                                src={URL.createObjectURL(file)}
                                                                                alt="Preview"
                                                                                style={{ maxWidth: '40px', maxHeight: '40px', }}
                                                                            />
                                                                        ) : (
                                                                            <span className='d-flex'><img src={Docmnt} className='fileimg' />  </span>
                                                                        )} */}
                                                            <button className='dltbtn' type="button" onClick={() => handleDeleteFile(stn.handler_feedback_id)}> <FontAwesomeIcon icon={faCircleXmark} color='#656565' /></button>
                                                        </div>
                                                    )
                                                })}
                                            </div>
                                        </div>
                                    ))}
                                </div>
                                <div className='ordernext'>
                                    <Button className='next_cancel' variant="danger" onClick={() => window.location.replace('/OverviewDetails')}>
                                        Cancel
                                    </Button>
                                    <Button className='trnext' variant="contained" onClick={handleUpdate}>
                                        Update
                                    </Button>
                                </div>
                            </div>
                        </div>
                    }

                </div>
            </div>
        </>
    )
}

export default UpdateRecoveryCase;
